import { render } from "./BaseCard.vue?vue&type=template&id=227819b7&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=227819b7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anteater\\Desktop\\projects\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227819b7"]])

export default __exports__